import { render } from "./BaseNumber.vue?vue&type=template&id=de5c1a8a"
import script from "./BaseNumber.vue?vue&type=script&lang=js"
export * from "./BaseNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__